module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t(("profile.kyc.document.type." + ([_vm.document.Type])))))]), _vm._v(" "), (_vm.documentExists) ? _c('kyc-status', {
    attrs: {
      "kycDocument": _vm.document
    }
  }) : _vm._e(), _vm._v(" "), (_vm.documentCreated || _vm.documentRefused || !_vm.documentExists) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.successInfo))]), _vm._v(" "), _c('upload-base64', {
    ref: "file_input",
    staticClass: "btn btn-default pt-0",
    attrs: {
      "multiple": false,
      "done": _vm.addFiles
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default button-wide-crowd",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.file_input.$refs.input.click();
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('profile.kyc.addDocumentPage')) + "\n    ")]), _vm._v(" "), [(_vm.pages.length) ? _c('p', [_vm._v(_vm._s(_vm.$t('profile.kyc.addedDocuments')) + " " + _vm._s(_vm.pages.length))]) : _vm._e(), _vm._v(" "), (_vm.pages.length) ? _c('button', {
    staticClass: "btn btn-default button-wide-crowd",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('profile.kyc.removeDocuments')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default button-wide-crowd",
    attrs: {
      "type": "button",
      "disabled": !_vm.pages.length
    },
    on: {
      "click": function($event) {
        return _vm.savePages()
      }
    }
  }, [_c('clip-loader', {
    attrs: {
      "loading": _vm.processing.savePages,
      "size": '15px',
      "color": 'white'
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.processing.savePages),
      expression: "!processing.savePages"
    }]
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], _vm._v(" "), (_vm.documentCreated) ? _c('div', [_c('button', {
    staticClass: "btn btn-default button-wide-crowd",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitDocument()
      }
    }
  }, [_c('clip-loader', {
    attrs: {
      "loading": _vm.processing.submit,
      "size": '15px',
      "color": 'white'
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.processing.submit),
      expression: "!processing.submit"
    }]
  }, [_vm._v(_vm._s(_vm.$t('profile.kyc.submitForVerification')))])], 1)]) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d06dcad6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organization/Document.vue
// module id = 835
// module chunks = 1